module.exports = __webpack_public_path__ + "img/Cold Brew Coffee.36ce9a27.svg";